import BaseProxy from './BaseProxy';

class Auth extends BaseProxy {
    constructor(parameters = {}) {
        super('/api/v1/topic/statuses', parameters);
    }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/api/TopicStatus.js